import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import { ErrorState } from './states.js';
/**
 * Catches a render error in its subtree.
 *
 * A React error boundary must be a class component; there is no hook
 * equivalent, and `componentDidCatch` is the only way to see the component
 * stack.
 *
 * Note what this does *not* catch: errors thrown in event handlers, in
 * `setTimeout`, or in a rejected promise. Those never pass through render, so
 * the boundary is blind to them and the application keeps running with the
 * failure unreported. Async failures belong to the query layer's error state,
 * not here.
 */
export class ErrorBoundary extends Component {
    state = { error: null };
    static getDerivedStateFromError(error) {
        return { error };
    }
    componentDidCatch(error, info) {
        this.props.onError?.(error, info.componentStack ?? '');
    }
    componentDidUpdate(previous) {
        if (this.state.error !== null && previous.resetKey !== this.props.resetKey) {
            this.reset();
        }
    }
    reset = () => {
        this.setState({ error: null });
    };
    render() {
        const { error } = this.state;
        if (error === null)
            return this.props.children;
        if (this.props.fallback !== undefined)
            return this.props.fallback(error, this.reset);
        return (_jsx(ErrorState, { title: "This section could not be displayed", description: "The page has been left as it was. Reloading usually clears it.", onRetry: this.reset }));
    }
}
//# sourceMappingURL=error-boundary.js.map